// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { px, mb, mt } from 'styled-components-spacing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import theme from '@theme';
import { Dialog } from '@components';

const { colors } = theme;

export const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  position: relative;

  font-size: 18px;

  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  ${breakpoint('desktop')`
    overflow: hidden;

    position: static;
  `}
`;

export const StyledDialogContent = styled(Dialog.DialogContent)`
  && {
    display: flex;

    margin: 0;
    ${px(4.5)}

    ${breakpoint('desktop')`
      background-color: ${colors.greyBlue10};
      overflow: hidden;
    `}
  }
`;

export const StyledDialogHeader = styled(Dialog.DialogHeader)`
  position: absolute;
  right: 0;
  top: 0;
  left: 0;

  background-color: ${colors.white};

  z-index: 111;

  ${mb(3)}

  ${breakpoint('desktop')`
    position: static;

    font-size: 24px;

    display: flex;
    justify-content: space-between;
    
    padding: 0;
    padding-top: 3rem;

    background-color: transparent;
  `}
`;

export const StyledHeaderCloseIcon = styled(FontAwesomeIcon)`
  margin-top: 5px;
  cursor: pointer;
  ${breakpoint('desktop')`
    margin-top: 0;
  `}
`;

export const StyledHeaderText = styled.span`
  margin-left: 10px;
  line-height: 1.4;

  text-align: center;

  flex: 1;

  ${breakpoint('desktop')`
    margin-left: 0;
    text-align: left;
  `}
`;

export const StyledDescriptionText = styled.p`
  font-size: 18px;

  max-width: 43rem;
  height: 63px;

  ${mt(5)}
  ${mb(3)}

  ${breakpoint('desktop')`
    height: 40px;
    ${mt(0)}
  `}
`;

export const StyledThanksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: 5rem;

  text-align: center;

  ${breakpoint('desktop')`
    flex: 0.7;
    justify-content: center;

    margin-top: 0;
  `}
`;

export const StyledThanksTitle = styled.div`
  font-size: 2rem;
  font-weight: 600;

  line-height: 4rem;
  color: ${colors.defaultGreen};
`;

export const StyledThanksText = styled.div`
  font-size: 1.25rem;
  line-height: 2rem;
`;
